export { seoDataSchema } from './schema';
export { SEOData, DEFAULT_SHARE_IMAGE_URL } from './SEOData';
export type { SEODataProps } from './SEOData';
